import axios, {AxiosError} from "axios";
import { API_URL, FetchFilingResult, LateFilingData, UpdateDTRResponse, UpdateDTRResult } from "../constant";
import { FetchLateResult} from "../constant";
  
export async function FectchLateFilings(licenseNumber: string): Promise<FetchLateResult> {

    try {
        const token = localStorage.getItem("token")
        const data ={licenseNumber: licenseNumber}

        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
          };
      
        const response = await axios.post(
          `${API_URL}api/late/getLate`,
          data,
          config
        );
    
        if (response.status === 200)
        {
            console.log(`Fetch filing history success, ${response.data.length}`);
            return { success: true, filing: response.data };
        }
        else if (response.status === 500)
        {
            return { success: false, errorMsg: "Internal Server Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function api_fetchFilingbyDtrId(dtrid: number): Promise<FetchFilingResult> {

    try {
        const token = localStorage.getItem("token")
        const data ={DTRID: dtrid}
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
          };

        //message.loading({ content: 'Filing fetching...', key: 'fetchStatus' });
        const response = await axios.post(
          `${API_URL}api/late/fetchfilingsbydtr`,
          data,
          config
        );
    
        if (response.status === 200)
        {
            return { success: true, fetchedList: response.data };
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function api_updateDTR(requestdata: LateFilingData): Promise<UpdateDTRResult> {
    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
          };
      
        const response = await axios.post(
          `${API_URL}api/late/updatedtr`,
          requestdata,
          config
        );
    
        if (response.status === 200)
        {
            return { success: true, dtr: response.data };
        }
        else if (response.status === 400)
        {
            return { success: false, errorMsg: response.data.detail || "Validation Error" }; 
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}